import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const SEND_REQUEST_WHITE_LABEL_ACCESS = gql(`
  mutation sendRequestWhiteLabelAccess($whiteLabelId: ID!, $email: String!, $message: String){
    sendRequestWhiteLabelAccessMail(input:  {
       whiteLabelId: $whiteLabelId
       email: $email
       message: $message
    }) {
      __typename
      ... on RequestWhiteLabelAccessMail {
        __typename
        email
        message
      }
      ... on InvalidEmail {
        __typename
        email
      }
      ... on WhiteLabelConfigNotFound {
        __typename
        id
      }
    }
  }
`);

export function useSendRequestWhiteLabelAccess() {
  return useMutation(SEND_REQUEST_WHITE_LABEL_ACCESS);
}
